import * as AppConstants from "AppConstants";

/**
 * Replaces clientId placeholder with actual client id value
 * @returns members for client URL to be fired  - 
 * GET /v1/api/clients/{clientId}/members
 * Example output to return: http://localhost:8081/v1/api/clients/100/members
 * */
 export const getUrlForUserByEmail = (email) => {
    const url = AppConstants.GET_USER_DETAILS_BY_EMAIL
                    .replace(AppConstants.USER_EMAIL_PLACEHOLDER, email);
    return url;
};

 export const getUrlToChangePassword = (id) => {
    const url = AppConstants.CHANGE_PASSWORD_ENDPOINT
                .replace(AppConstants.USER_ID_PLACEHOLDER, id);
    return url;
};

 export const getUrlToFetchAllUsers = () => {
    const url = AppConstants.FETCH_ALL_USERS_ENDPOINT;
    return url;
};

 export const getUrlToFetchUsersByRole = (role) => {
    const url = AppConstants.FETCH_USERS_BY_ROLE_ENDPOINT
                .replace(AppConstants.ROLE_PLACEHOLDER, encodeURIComponent(role));
    return url;
};

 export const getUrlToCreateUser = () => {
    const url = AppConstants.CREATE_USER_ENDPOINT;
    return url;
};

 export const getUrlToUpdateUser = (user_id) => {
    const url = AppConstants.UPDATE_USER_ENDPOINT
                .replace(AppConstants.USER_ID_PLACEHOLDER, user_id);
    return url;
};

 export const getUrlToDeleteUser = (user_id) => {
    const url = AppConstants.DELETE_USER_ENDPOINT
                .replace(AppConstants.USER_ID_PLACEHOLDER, user_id);
    return url;
};